import tunnel from 'tunnel-rat';

export const r3f = tunnel();
